import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-mat-menu-header',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './mat-menu-header.component.html',
    styleUrls: ['./mat-menu-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatMenuHeaderComponent {}
